import { Button, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React, { useState, useEffect } from 'react'
import MainCard from 'ui-component/cards/MainCard'
import SubCard from 'ui-component/cards/SubCard'
import { IoMdArrowBack } from "react-icons/io";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import FieldsTable from './FieldsTable'
import { GetAllRequest, ProvideApproval, ProvideReject } from 'API/Ds Approval/api'
import { getConfigData } from 'API/Config/api'
import ReajectReason from './Components/ReajectReasonBox'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import TablePagination from '@mui/material/TablePagination';
import BackdropLoader from '../General/Loader'






function PendingForm() {
    // const style={width:'100%',display:'flex',gap:'30px',flexDirection:'row'}

    const [data, setData] = useState(null)
    const [value, setValue] = React.useState(null);
    const [Selected, setSelected] = React.useState(null);
    const [configData, setConfigData] = useState(null)
    const [selectedProducts, setSelectedProducts] = React.useState(null);
    // const [PostData, setPostData] = React.useState(null);
    const [RejectReason, setRejectReason] = useState(null);
    const userType = sessionStorage.getItem('UserType')
    const user_id = sessionStorage.getItem('user_id')
    const [open, setOpen] = React.useState(false);
    const [AlertOpen, setAlertOpen] = useState(false);
    const [AlertMessage, setAlertMessage] = useState(null);
    const [AlertType, setAlertType] = useState('success');
    const [disableButtons, setDisableButtons] = useState(false);
    const [Page, setPage] = useState(0)
    const [IsLoading, setIsLoading] = useState(false)
    const [TotalCount, setTotalCount] = useState(0)

    const handleAlertOpen = () => {
        setAlertOpen(true)
    }

    console.log(AlertOpen);

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertOpen(false);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleRejectClose = () => {
        setOpen(false);
    };
    // const [open, setOpen] = React.useState(false);
    // const[alertType,setAlertType]=useState('success')

    // const handleClick = () => {
    //     setOpen(true);
    // };

    // const handleAlertClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }

    //     setOpen(false);
    // };



    const smStyles = {
        width: '100%', display: 'flex', gap: '30px',
        flexDirection: 'column',
    };

    const mdLgXlStyles = {
        width: '100%', display: 'flex', gap: '30px',
        flexDirection: 'row',
    };

    const handleSelect = () => {
        setSelected(value)
    }

    const handleItemClick = (index) => {
        setValue(data[index]);
        setSelectedProducts(data[index])
    };

    console.log('Selected ', selectedProducts);

    console.log('value ', value);


    // function createData(name) {
    //     return { name };
    // }


    const [rows, setRows] = React.useState([])

    // React.useEffect(() => {
    //     if (Selected) {
    //         Selected.fields.forEach(element => {
    //             setRows(prevRows => [...prevRows, createData(element.title)]);
    //         });
    //     }

    // }, [Selected])

    useEffect(() => {
        GetAllRequest(Page + 1, setData, setIsLoading, setTotalCount)
        getConfigData(setConfigData)
    }, [])

    const handleClose = () => {
        // setSelected(null)
        setAlertOpen(false)
        setRows([])
        setSelectedProducts(null)
        setSelected(null)
        setValue(null)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        GetAllRequest(newPage + 1, setData, setIsLoading, setTotalCount)
    };


    const handleSelectedClose = () => {
        setSelected(null)
    }
    console.log("id ", user_id);

    const handleApprove = () => {
        console.log(value, selectedProducts,);
        if ((userType === 'ops' || userType === 'rm' || userType === 'sh' || userType === 'cso') && selectedProducts) {
            ProvideApproval(selectedProducts.user_id, setData, handleClose, setAlertMessage, handleAlertOpen, setAlertType, setDisableButtons, handleSelectedClose)
        }
        else {
            setAlertType("error")
            setAlertMessage("Please try again")
            handleAlertOpen()
            setTimeout(() => {

                handleClose()
            }, 1500)
        }
    }

    const handleRejectOpen = () => {
        // if (userType === 'tm') {
        //     setPostData({
        //         "product_id": value.product_id,
        //         "status": "rejected",
        //         "user_id": value.user_id
        //     })
        // }
        handleClickOpen()
    }

    const handleReject = () => {
        console.log(value, selectedProducts);
        if (userType === 'ops' && RejectReason) {
            // setPostData({
            //             "product_id": value.product_id,
            //             "status": "rejected",
            //             "user_id": value.user_id,
            //             "rejected_reason":RejectReason
            //         })
            ProvideReject(selectedProducts.user_id, setData, handleClose, setAlertMessage, handleAlertOpen, setAlertType, setDisableButtons, handleSelectedClose)
        }
    }


    console.log("data", data);

    console.log("selected", Selected);


    return (
        <>
            <BackdropLoader open={IsLoading} />
            {
                Selected ?
                    <div style={{ height: '60vh', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                        <Snackbar open={AlertOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={3000} onClose={handleClose}>
                            <Alert
                                onClose={handleAlertClose}

                                severity={AlertType}
                                variant="filled"
                                sx={{ width: '100%' }}
                            >
                                {AlertMessage}
                            </Alert>
                        </Snackbar>
                        <ReajectReason open={open} handleClose={handleRejectClose} setRejectReason={setRejectReason} handleReject={handleReject} />
                        <div>
                            <Stack direction='row' alignItems='center' justifyContent='space-between' >
                                <Button sx={{ width: '20px' }} onClick={handleSelectedClose}><IoMdArrowBack style={{ color: 'black', fontSize: '20px' }} /></Button>
                                <Typography variant='subtitle1' color='grey'>{Selected.title}</Typography>
                            </Stack>
                            <TableContainer component={Paper}>
                                <FieldsTable userType={userType} configData={configData} rows={rows} selectedItem={Selected} />
                            </TableContainer>
                        </div>
                        <Stack direction='row' width='100%' justifyContent='flex-end' spacing={1}>
                            <Button color='success' variant='contained' disabled={disableButtons} onClick={handleApprove}>Approve</Button>
                            <Button color='error' variant='contained' disabled={disableButtons} onClick={() => handleRejectOpen()}>Reject</Button>
                        </Stack>
                    </div>
                    :
                    data && data.length > 0 ?
                        <div
                            style={window.innerWidth >= 600 ? mdLgXlStyles : smStyles}>
                            <div style={{ height: window.innerWidth >= 600 ? '70vh' : '30vh', overflowY: 'scroll', width: '100%', scrollbarWidth: 'none' }}>
                                <Stack spacing={2} sx={{ width: '100%', height: '70rem' }}>

                                    {data && data.map((item, index) => {
                                        return (

                                            (userType === 'ops') || (userType === 'sh') || (userType === 'rm')) ?

                                            <SubCard title={`Onboarding for ${item.user_name}`} key={index} sx={{ cursor: 'pointer' }} onClick={() => handleItemClick(index)}>
                                                <Stack direction='column' >
                                                    <div></div>
                                                    <Stack direction='column'>
                                                        <Typography variant='subtitle1' color='grey'>Date: {item.date ? item.date : ''}</Typography>
                                                        <Typography variant='subtitle1' color='grey'> Time:{item.time ? item.time : ''}</Typography>
                                                    </Stack>
                                                </Stack>
                                            </SubCard>
                                            :
                                            null
                                    }
                                    )}
                                    <TablePagination
                                        component="div"
                                        count={TotalCount ? TotalCount : 0}
                                        page={Page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}

                                    />
                                </Stack>
                            </div>
                            <Stack sx={{ width: '100%', display: 'flex', visibility: value ? 'visible' : 'hidden' }}>
                                <MainCard sx={{ width: '100%', backgroundColor: 'whitesmoke' }}>
                                    <SubCard title={value ? value.user_name : ''}>
                                        <Stack direction='column' >
                                            <div></div>
                                            <Stack direction='column' spacing={1} >
                                                <Typography variant='h5'>{value ? `Date: ${value.date}` : null}</Typography>
                                                <Typography variant='h5'>{value ? `Time: ${value.time}` : ''}</Typography>
                                                <Button variant='contained' sx={{ backgroundColor: '#A556B2' }} onClick={handleSelect}>View Request</Button>
                                            </Stack>
                                        </Stack>
                                    </SubCard>
                                </MainCard>
                            </Stack>
                        </div>
                        :
                        <Typography variant='subtitle1' color='grey'>No data</Typography>
            }

        </>
    )
}

export default PendingForm
